import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApiCore } from "contexts";
import { type MediaDataRoomV3 } from "features/mediaDataRoom/models";

export interface MediaDataRoomQueryHookPayload {
  dataRoomId: string;
  skip?: boolean;
}

export type MediaDataRoomQueryHookResult = UseQueryResult<
  MediaDataRoomV3,
  Error
>;

const useMediaDataRoomQuery = ({
  dataRoomId,
  skip,
}: MediaDataRoomQueryHookPayload) => {
  const {
    client,
    getSession,
    driverMrsignerAttestationSpecHash,
    getVerificationKey,
  } = useApiCore();
  return useQuery({
    enabled: !skip,
    queryFn: async () => {
      const session = await getSession();
      const verificationKey = await getVerificationKey(session);
      const mediaDataRoom = await client.getDataRoom(
        dataRoomId,
        verificationKey
      );
      if (mediaDataRoom.state.kind !== "media") {
        throw new Error("Requested data clean room is not media data room");
      }
      return {
        ...mediaDataRoom,
        driverAttestationHash: driverMrsignerAttestationSpecHash,
      };
    },
    queryKey: ["v0", "mediaDataRoom", dataRoomId],
  });
};

export default useMediaDataRoomQuery;
